export const mentorsFaq = [
  {
    q: "What are the eligibility criteria to become an IMPARC mentor?",
    a: "To become a mentor, you must hold a Ph.D. or equivalent qualification, minimum 5 years of research experience, at least 10 peer-reviewed publications, and a strong commitment to academic mentorship.",
  },
  {
    q: "How much time commitment is expected from mentors?",
    a: "Mentors can decide their availability and engagement level with mentees.",
  },
  {
    q: "What benefits do mentors receive?",
    a: "Mentors gain recognition, networking opportunities, and access to exclusive IMPARC resources.",
  },
  {
    q: "How are mentors matched with mentees?",
    a: "Matching is based on research interests, expertise, and mentee requirements.",
  },
  {
    q: "Can mentors work with multiple mentees simultaneously?",
    a: "Yes, mentors can guide multiple mentees at the same time.",
  },
];

export const authorFaq = [
  {
    q: "Can mentors work with multiple mentees simultaneously?",
    a: "Yes, provided they meet the requirements of publications and mentoring commitments.",
  },
  {
    q: "Can I access mentorship as an author member?",
    a: "Yes, author members can apply for mentorship programs.",
  },
  {
    q: "What networking opportunities are provided?",
    a: "Members can attend IMPARC events, workshops, and collaborative sessions.",
  },
  {
    q: "What publication opportunities are available?",
    a: "Author members can publish in IMPARC journals and indexed platforms.",
  },
  {
    q: "How are publications peer-reviewed?",
    a: "All publications undergo a structured peer-review process by experts.",
  },
  {
    q: "Are there any membership fees?",
    a: "Membership fees vary depending on the category and benefits chosen.",
  },
  {
    q: "Can I withdraw my membership?",
    a: "Yes, members can withdraw by submitting a formal request.",
  },
  {
    q: "How can I update my research profile?",
    a: "Profiles can be updated through the member dashboard.",
  },
];

export const institutionsFaq = [
  {
    q: "What is a Knowledge Hub?",
    a: "Knowledge Hubs connect institutions, host events, and facilitate research collaborations.",
  },
  {
    q: "What are the eligibility criteria for becoming a Hub?",
    a: "Institutions must have recognized accreditation and research capacity.",
  },
  {
    q: "What support does IMPARC provide to Hubs?",
    a: "IMPARC provides academic resources, networking, and collaboration tools.",
  },
  {
    q: "How long is the Hub partnership?",
    a: "The partnership duration is decided mutually between IMPARC and the institution.",
  },
];

export const cacFaq = [
  {
    q: "What is CAC (Collaborative Academic Center)?",
    a: "CACs are premium institutions with enhanced partnership status offering advanced research facilities.",
  },
  {
    q: "What additional benefits do CACs receive?",
    a: "Access to global collaborations, branding, and research support.",
  },
  {
    q: "How can a Hub upgrade to CAC status?",
    a: "Institutions can apply for upgrade based on performance and eligibility.",
  },
  {
    q: "What are the eligibility criteria for CAC status?",
    a: "Institutions must meet higher research and academic benchmarks.",
  },
];

export const generalFaqPublishing = [
  {
    q: "What publication options are available?",
    a: "IMPARC offers journals, conference proceedings, ISBN books, edited volumes, and special issues in collaboration with international publishers",
  },
  {
    q: "What is the peer review process?",
    a: "All publications undergo rigorous double-blind peer review by subject experts, ensuring high academic standards and quality.",
  },
  {
    q: "How long does the review process take?",
    a: "Initial review takes 4-6 weeks, revision rounds 2-3 weeks each. Complete process typically takes 8-12 weeks from submission to decision.",
  },
  {
    q: "Are there publication fees?",
    a: "Most publications are free for members. Non-members may have nominal processing fees ranging from ₹3,000-₹8,000 depending on publication type.",
  },
];
export const generalFaqEvents = [
  {
    q: "How can I participate in IMPARC events?",
    a: "Events are announced on our website and through newsletters. Registration is typically free for members, with nominal fees for non-members.",
  },
  {
    q: "Are publications indexed in major databases?",
    a: "Yes, our publications are indexed in Scopus, Web of Science, Google Scholar, DOAJ, and other reputable academic databases.",
  },
  {
    q: "Can institutions host IMPARC events?",
    a: "Yes, partner institutions can host conferences, workshops, and seminars with IMPARC support including speakers, promotion, and certification.",
  },
  {
    q: "How can I get DOI for my publication?",
    a: "All accepted publications automatically receive DOI registration through our partnership with CrossRef and other DOI registration agencies.",
  },
];
export const generalFaqCertificates = [
  {
    q: "What certificates are provided?",
    a: "We provide participation certificates for events, publication certificates, mentorship completion certificates, and recognition awards.",
  },
  {
    q: "How can I verify certificate authenticity?",
    a: "All certificates have unique verification codes and QR codes that can be verified on our official website through the verification portal.",
  },
  {
    q: "How do I contact IMPARC support?",
    a: "Contact us via email at support@imparc.org, phone +91-xxx-xxx-xxxx, or through the contact form on our website for assistance. ",
  },
  {
    q: "Is IMPARC internationally recognized?",
    a: "Yes, IMPARC has international recognition with partnerships across 25+ countries and collaborations with leading global academic institutions.",
  },
];
